/**
 * Ecran des joueurs sans role : spectateur elimine, ou joueur qui attend que
 * l'unique dessinateur de la manche ait fini.
 *
 * Il existe parce que les deux nouveaux modes laissent des joueurs sans tableau
 * a dessiner ni retouche a chercher. Sans lui, ils restaient sur un chargement
 * qui ne se terminait jamais, ce qui ressemble a un plantage.
 */
import type { ReactElement, ReactNode } from 'react';
import type { RoomSnapshot } from '@retusch/shared';
import { Avatar } from './Avatar.js';
import { PhaseTimer } from './PhaseTimer.js';

export function Watching({
  title,
  subtitle,
  room,
  durationMs,
  children,
}: {
  title: string;
  subtitle: string;
  room: RoomSnapshot;
  /** Duree de la phase en cours, pour le compte a rebours. */
  durationMs: number;
  children?: ReactNode;
}): ReactElement {
  return (
    <main className="watching">
      {/* Sans compte a rebours, celui qui attend ignore combien de temps il
          attend, ce qui transforme une pause en impression de blocage. */}
      <div className="watching__timer">
        <PhaseTimer endsAt={room.endsAt} durationMs={durationMs} size={64} />
      </div>

      <p className="watching__title">{title}</p>
      <p className="watching__subtitle">{subtitle}</p>

      {children}

      <div className="watching__players">
        {room.players.map((player) => (
          <div className="watching__player" key={player.id} data-out={player.eliminated}>
            <Avatar
              playerId={player.id} avatar={player.avatar}
              colorIndex={player.colorIndex}
              size={40}
              dimmed={!player.connected || player.eliminated}
              done={player.done}
            />
            <span className="watching__name">{player.nickname}</span>
          </div>
        ))}
      </div>
    </main>
  );
}
